module.exports = __webpack_public_path__ + "img/ln.4f70e49c.png";